import { differenceInMilliseconds } from 'date-fns';

export const calcDayDifference = (endDate: Date, startDate: Date) => {
  const msPerDay = 1000 * 60 * 60 * 24;
  const realDiff = differenceInMilliseconds(endDate, startDate) / msPerDay;
  const diff = Math.ceil(realDiff);
  return Math.max(diff, 0);
};
